import produce from "immer";
import IInvoicesReducer from "models/IInvoicesReducer";
import { actionTypes } from "./actions";
import { invoiceSorting as defaultSorting } from "constants/sorting";

const initialState: IInvoicesReducer = {
  isLoading: false,
  isLoaded: false,
  optionsLoaded: false,
  items: [],
  meta: {
    defaultSorting
  },
  invoiceLines: [],
  invoiceDeliveries: [],
  deliveryNotes: [],
  currentItem: null,
  error: null,
  typeOptions: [],
  purchaseTypes: []
};

export default (state = initialState, action: any) =>
  // @ts-ignore
  produce(state, draftState => {
    switch (action.type) {
      case actionTypes.GET_INVOICES_SUCCESS:
        draftState.items = action.payload;
        draftState.meta = action.meta;
        break;
      case actionTypes.GET_INVOICES_FAILURE:
        draftState.error = action.error;
        break;
      case actionTypes.GET_INVOICE_REQUEST:
        draftState.currentItem = null;
        break;
      case actionTypes.GET_INVOICE_SUCCESS:
        draftState.currentItem = action.payload;
        break;
      case actionTypes.GET_INVOICE_LINES_REQUEST:
        draftState.isLoading = true;
        break;
      case actionTypes.GET_INVOICE_LINES_SUCCESS:
        draftState.isLoading = false;
        draftState.isLoaded = true;
        draftState.invoiceLines = action.payload;
        break;
      case actionTypes.GET_INVOICE_DELIVERIES_REQUEST:
        draftState.isLoading = true;
        break;
      case actionTypes.GET_INVOICE_DELIVERIES_SUCCESS:
        draftState.isLoading = false;
        draftState.isLoaded = true;
        draftState.invoiceDeliveries = action.payload;
        break;
      case actionTypes.GET_INVOICE_SELECT_OPTIONS_REQUEST:
        draftState.typeOptions = [];
        draftState.purchaseTypes = [];
        draftState.optionsLoaded = false;
        break;
      case actionTypes.GET_INVOICE_SELECT_OPTIONS_SUCCESS:
        draftState.typeOptions = action.payload.typeOptions;
        draftState.purchaseTypes = action.payload.purchaseTypes;
        break;
    }
  });
